import { SelectOptions } from '@spo/logic';
import { SpoSegmentationTypesResponse } from '@spo/types';
import { useEffect, useState } from 'react';
import { InputActionMeta } from 'react-select';
import { useUserSegmentation } from '../../../hooks/useUserSegmentation';
import { metaActions } from '../../../utils/metaActions';
import { SelectionInput } from '../../offerPosterModal/selectionInput/SelectionInput';

export const noSegmentationOption = {
  label: '0 - No segmentation',
  name: 'No segmentation',
  value: 0,
};

type UsageSegmentationSearchInputProps = {
  usageSegmentationByIds: SpoSegmentationTypesResponse;
  selectedUsageSeg: number | null;
  existingUsageSeg: string;
  setSelectedUsageSeg: (value: number | null) => void;
  isSelectDisabled?: boolean;
};

export const UsageSegmentationSearchInput = ({
  usageSegmentationByIds,
  selectedUsageSeg,
  existingUsageSeg,
  setSelectedUsageSeg,
  isSelectDisabled,
}: UsageSegmentationSearchInputProps) => {
  const [inputValue, setInputValue] = useState('');
  const [userSegOptions, setUserSegOptions] = useState<SelectOptions[]>([]);

  const { data: userSegmentation } = useUserSegmentation(inputValue);

  useEffect(() => {
    if (usageSegmentationByIds && usageSegmentationByIds.length > 0) {
      setSelectedUsageSeg(usageSegmentationByIds[0].typeId);
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setInputValue(usageSegmentationByIds[0].englishName);
    }
  }, [usageSegmentationByIds]);

  useEffect(() => {
    if (userSegmentation && userSegmentation.length > 0) {
      const userSegListOptions: SelectOptions[] = userSegmentation?.map(
        (userSeg) => ({
          label: `${userSeg.typeId} - ${userSeg.englishName}`,
          value: userSeg.typeId,
          name: `${userSeg.englishName}`,
        }),
      );
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setUserSegOptions([noSegmentationOption, ...userSegListOptions]);
    }
  }, [userSegmentation]);

  const onInputChange = (search: string, actionMeta: InputActionMeta) => {
    if (actionMeta.action === metaActions.inputChange) {
      setInputValue(search);
    }
  };

  return (
    <SelectionInput
      entities={userSegOptions}
      selectedEntity={selectedUsageSeg}
      placeholder={existingUsageSeg}
      entityType="usage-segmentation"
      handleEntitySelection={setSelectedUsageSeg}
      onInputChange={onInputChange}
      isSelectDisabled={isSelectDisabled}
      architecture
      hideLabel
    />
  );
};
